import Fetch from "./index";

export const login = async (email, password) => {
    if (!email || !password)
        return Promise.reject("missing email or password");

    return Fetch("/auth/", {
        method: 'POST',
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({email, password})
    })
}

export const refresh = async () => {
    return Fetch("/auth/", {
        method: 'PUT',
        headers: {
            "Content-Type": "application/json",
        },
    })
}

export const forgotPassword= async (data)=> {
    return Fetch('/auth/forgot-password',{
    method: 'POST',
    body: JSON.stringify(data),
    headers: {
        "Content-Type": "application/json",
    }}
    )
}
export const resetPassword= async (data)=> {
    return Fetch('/auth/forgot-password',{
    method: 'PUT',
    body: JSON.stringify(data),
    headers: {
        "Content-Type": "application/json",
    }}
    )
}

export const logout = async (navigate) => {
  localStorage.removeItem('user')
  localStorage.removeItem('token')
  navigate('/login')
}

export const googleLogin = async (token) => {
  return Fetch('/auth/google', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ token }),
  })
}

export const googleRegister = async (token, planType) => {
  if (planType === undefined || planType === null) {
    return Promise.reject(new Error('A planType is required for Google registration.'))
  }
  return Fetch(`/auth/google-register/${planType}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ token }),
  })
}
